class WelcomeScratchPopup extends HTMLElement {
  constructor() {
    super();
    this.storageDismissKey = 'yina_popup_dismissed_until';
    this.storageSubscribedKey = 'yina_popup_subscribed';
    this.returnMarkerParam = 'yina_popup_subscribed';
    this.sessionShownKey = 'yina_popup_shown_session';
  }

  connectedCallback() {
    this.fixReturnTo();

    if (this.shouldSkip()) return;

    this.settings = this.readSettings();
    this.panel = this.querySelector('.welcome-popup__panel');
    this.scratchStage = this.querySelector('[data-stage="scratch"]');
    this.discountStage = this.querySelector('[data-stage="discount"]');
    this.scratchCard = this.querySelector('[data-scratch]');
    this.canvas = this.querySelector('[data-scratch-canvas]');
    this.revealFallback = this.querySelector('[data-reveal-fallback]');
    this.applyDiscountButton = this.querySelector('[data-apply-discount]');
    this.copyButton = this.querySelector('[data-copy-code]');
    this.copySuccessMessage = this.querySelector('[data-copy-success]');
    this.formView = this.querySelector('[data-newsletter-form-view]');
    this.successView = this.querySelector('[data-success-view]');

    this.bindCloseHandlers();
    this.bindRevealFallback();
    this.bindApplyDiscount();
    this.bindCopyButton();
    this.setupScratchCanvas();

    this.checkSubscribedRedirect();
    this.scheduleShow();
  }

  fixReturnTo() {
    try {
      const returnToInput = this.querySelector('input[name="return_to"]');
      if (!returnToInput) return;
      const url = new URL(window.location.href);
      url.searchParams.set(this.returnMarkerParam, '1');
      returnToInput.value = url.pathname + url.search;
    } catch (e) {
      /* si algo falla, se queda el valor por defecto de Liquid (request.path) */
    }
  }

  showFormView() {
    if (this.formView) this.formView.hidden = false;
    if (this.successView) this.successView.hidden = true;
  }

  showSuccessView() {
    if (this.formView) this.formView.hidden = true;
    if (this.successView) this.successView.hidden = false;
  }

  shouldSkip() {
    if (window.Shopify && window.Shopify.designMode) return false;
    // ANADIDO 30 oct: mientras la campana temporal de Halloween este activa (calculado en
    // Liquid, mismo instante que sections/halloween-intro.liquid), este popup cede la
    // prioridad y no se muestra, para no competir por la atencion de la clienta. El
    // descuento YINA10 sigue activo igualmente, solo se oculta este popup concreto.
    if (this.dataset.halloweenActive === 'true') return true;
    if (window.location.pathname.indexOf('/checkout') === 0) return true;
    try {
      if (sessionStorage.getItem(this.sessionShownKey) === 'true') return true;
    } catch (e) {
      /* sessionStorage unavailable: fail open rather than break */
    }
    try {
      if (localStorage.getItem(this.storageSubscribedKey) === 'true') return true;
      const until = parseInt(localStorage.getItem(this.storageDismissKey) || '0', 10);
      if (until && Date.now() < until) return true;
    } catch (e) {
      /* localStorage unavailable: fail open rather than break */
    }
    return false;
  }

  readSettings() {
    const el = this;
    const num = (attr, fallback) => {
      const v = el.dataset[attr];
      const n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    };
    return {
      delaySeconds: num('delaySeconds', 10),
      suppressDays: num('suppressDays', 7),
    };
  }

  scheduleShow() {
    let shown = false;
    const show = () => {
      if (shown) return;
      if (this.isCartOpen()) {
        setTimeout(show, 1000);
        return;
      }
      shown = true;
      document.removeEventListener('mouseleave', onExitIntent);
      clearTimeout(timer);
      this.open();
    };

    const timer = setTimeout(show, (this.settings.delaySeconds || 10) * 1000);

    const onExitIntent = (evt) => {
      if (evt.clientY <= 0) show();
    };

    const isDesktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isDesktopPointer) {
      document.addEventListener('mouseleave', onExitIntent);
    }
  }

  isCartOpen() {
    const dialog = document.querySelector('.cart-drawer__dialog');
    return !!(dialog && dialog.open);
  }

  open() {
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    this.previouslyFocused = document.activeElement;
    const closeBtn = this.querySelector('.welcome-popup__close');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', this.onKeydown = (e) => {
      if (e.key === 'Escape') this.close();
    });
    try {
      sessionStorage.setItem(this.sessionShownKey, 'true');
    } catch (e) {
      /* ignore */
    }
  }

  close() {
    this.classList.remove('is-open');
    this.hidden = true;
    document.removeEventListener('keydown', this.onKeydown);
    this.persistSuppression();
    if (this.previouslyFocused && this.previouslyFocused.focus) {
      this.previouslyFocused.focus();
    }
  }

  persistSuppression() {
    try {
      const until = Date.now() + (this.settings.suppressDays || 7) * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.storageDismissKey, String(until));
    } catch (e) {
      /* ignore */
    }
  }

  bindCloseHandlers() {
    this.querySelectorAll('[data-popup-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
  }

  bindRevealFallback() {
    if (!this.revealFallback) return;
    this.revealFallback.addEventListener('click', () => this.revealPrize());
  }

  bindApplyDiscount() {
    if (!this.applyDiscountButton) return;
    this.applyDiscountButton.addEventListener('click', () => {
      this.persistSuppression();
      const code = this.applyDiscountButton.dataset.code || 'YINA10';
      const redirectTo = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectTo);
    });
  }

  bindCopyButton() {
    if (!this.copyButton) return;
    this.copyButton.addEventListener('click', () => {
      const code = this.copyButton.dataset.code || 'YINA10';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => this.showCopySuccess());
      }
    });
  }

  showCopySuccess() {
    if (!this.copySuccessMessage) return;
    this.copySuccessMessage.classList.remove('visually-hidden');
    clearTimeout(this.copySuccessTimer);
    this.copySuccessTimer = setTimeout(() => {
      this.copySuccessMessage.classList.add('visually-hidden');
    }, 2500);
  }

  checkSubscribedRedirect() {
    const errorMsg = this.querySelector('[data-form-error]');
    if (errorMsg) {
      this.goToDiscountStage();
      this.showFormView();
      this.open();
      return;
    }

    const serverSuccessMarker = this.querySelector('[data-form-success]');
    const urlIndicatesSuccess =
      window.location.search.indexOf('customer_posted=true') !== -1 ||
      window.location.search.indexOf(this.returnMarkerParam + '=1') !== -1;

    if (serverSuccessMarker || urlIndicatesSuccess) {
      try {
        localStorage.setItem(this.storageSubscribedKey, 'true');
      } catch (e) {
        /* ignore */
      }
      this.goToDiscountStage();
      this.showSuccessView();
      this.open();
    }
  }

  goToDiscountStage() {
    if (this.scratchStage) this.scratchStage.hidden = true;
    if (this.discountStage) this.discountStage.hidden = false;
  }

  revealPrize() {
    if (this.scratchCard) this.scratchCard.classList.add('is-revealed');
    setTimeout(() => this.goToDiscountStage(), 500);
  }

  setupScratchCanvas() {
    if (!this.canvas || !this.canvas.getContext) {
      this.revealPrize();
      return;
    }
    const ctx = this.canvas.getContext('2d');
    const width = this.canvas.width;
    const height = this.canvas.height;
    const scratchLabel = this.dataset.scratchLabel || 'Rasca aquí';

    const paintOverlay = () => {
      ctx.globalCompositeOperation = 'source-over';
      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#B29262');
      gradient.addColorStop(1, '#6B2737');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
      ctx.fillStyle = 'rgba(247, 244, 239, 0.9)';
      ctx.font = '13px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(scratchLabel, width / 2, height / 2);
    };
    paintOverlay();

    let scratching = false;
    let revealed = false;

    const scratchAt = (x, y) => {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, 18, 0, Math.PI * 2);
      ctx.fill();
    };

    const getPos = (evt) => {
      const rect = this.canvas.getBoundingClientRect();
      const point = evt.touches ? evt.touches[0] : evt;
      return {
        x: ((point.clientX - rect.left) / rect.width) * width,
        y: ((point.clientY - rect.top) / rect.height) * height,
      };
    };

    const checkRevealPercent = () => {
      if (revealed) return;
      const imageData = ctx.getImageData(0, 0, width, height).data;
      let transparent = 0;
      for (let i = 3; i < imageData.length; i += 4 * 20) {
        if (imageData[i] === 0) transparent++;
      }
      const total = imageData.length / (4 * 20);
      if (transparent / total > 0.45) {
        revealed = true;
        this.revealPrize();
      }
    };

    const start = (evt) => {
      scratching = true;
      const { x, y } = getPos(evt);
      scratchAt(x, y);
    };
    const move = (evt) => {
      if (!scratching) return;
      evt.preventDefault();
      const { x, y } = getPos(evt);
      scratchAt(x, y);
      checkRevealPercent();
    };
    const end = () => {
      scratching = false;
      checkRevealPercent();
    };

    this.canvas.addEventListener('pointerdown', start);
    this.canvas.addEventListener('pointermove', move);
    window.addEventListener('pointerup', end);
    this.canvas.addEventListener('touchstart', start, { passive: true });
    this.canvas.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('touchend', end);
  }
}

customElements.define('welcome-scratch-popup', WelcomeScratchPopup);
